module.exports = __webpack_public_path__ + "static/media/react-logo.0ad1d17f.png";